export const collocationQuestions = [
  {
    id: 1,
    koreanQuestion:
      "계약서에 서명하기 전에,  변호사가 _______ 이용 약관을 신중하게.",
    question:
      "Before signing the agreement, the lawyer will ______ the terms and conditions carefully.",
    choices: {
      a: "inspect",
      b: "review",
      c: "supervise",
      d: "investigate",
    },
    correctAnswer: "b",
    explanation:
      "'review the terms and conditions'(이용 약관을 검토하다)가 가장 자연스러운 콜로케이션입니다.\n\n'inspect'는 물리적인 점검(기계, 시설 검사)과 관련되어 부적절합니다.\n'supervise'는 사람이나 작업을 감독하는 의미로 부적절합니다.\n'investigate'는 범죄나 문제를 조사하는 의미로 부적절합니다.",
    translation:
      "계약서에 서명하기 전에 변호사가 이용 약관을 신중하게 검토할 것이다.",
  },
  {
    id: 2,
    koreanQuestion:
      "회사는 결정했다 _______ 새로운 마케팅 캠페인을 브랜드 인지도를 높이기 위해.",
    question:
      "The company decided to ______ a new marketing campaign to increase brand awareness.",
    choices: {
      a: "launch",
      b: "start",
      c: "create",
      d: "establish",
    },
    correctAnswer: "a",
    explanation:
      "'launch a campaign'(캠페인을 시작하다)이 가장 자연스러운 콜로케이션입니다.\n\n'start a campaign'도 문법적으로 가능하지만, 비즈니스 맥락에서는 'launch'가 더 적절합니다.\n'create a campaign'은 캠페인을 기획하는 의미에 가깝고 실행과는 다릅니다.\n'establish a campaign'은 어색한 조합입니다.",
    translation:
      "회사는 브랜드 인지도를 높이기 위해 새로운 마케팅 캠페인을 시작하기로 결정했다.",
  },
  {
    id: 3,
    koreanQuestion:
      "매니저는 제공했다 _______ 요약을 재무 보고서의  회의 중에.",
    question:
      "The manager provided a ______ summary of the financial report during the meeting.",
    choices: {
      a: "concise",
      b: "short",
      c: "brief",
      d: "compact",
    },
    correctAnswer: "c",
    explanation:
      "'brief summary'(간략한 요약)가 가장 자연스러운 콜로케이션입니다.\n\n'concise summary'도 가능하지만, 일반적으로 'brief summary'가 더 많이 사용됩니다.\n'short summary'는 의미는 통하지만 'brief'보다 덜 자연스럽습니다.\n'compact summary'는 물리적인 크기를 줄인 것처럼 들려서 어색합니다.",
    translation: "매니저는 회의 중 재무 보고서에 대한 간단한 요약을 제공했다.",
  },
  {
    id: 4,
    koreanQuestion:
      "프로젝트는 현재 _______ 일정대로 진행 중이다 그리고 완료될 예정이다. 다음달에 ",
    question:
      "The project is currently ______ schedule and is expected to be completed next month.",
    choices: {
      a: "on",
      b: "in",
      c: "at",
      d: "with",
    },
    correctAnswer: "a",
    explanation:
      "'on schedule'(일정대로 진행 중)이 가장 자연스러운 콜로케이션입니다.\n\n'in schedule'은 존재하지 않는 표현입니다.\n'at schedule'은 문법적으로 틀린 표현입니다.\n'with schedule'은 어색한 조합입니다.",
    translation:
      "프로젝트는 현재 일정대로 진행 중이며, 다음 달 완료될 예정이다.",
  },
  {
    id: 5,
    koreanQuestion:
      "회사는 목표로 하고 있다 _______ 고객 만족도를 응답 시간을 개선함으로써.",
    question:
      "The company aims to ______ customer satisfaction by improving response time.",
    choices: {
      a: "raise",
      b: "increase",
      c: "achieve",
      d: "develop",
    },
    correctAnswer: "c",
    explanation:
      "'achieve customer satisfaction'(고객 만족을 달성하다)이 가장 자연스러운 콜로케이션입니다.\n\n'increase customer satisfaction'도 가능하지만, 'achieve'가 더 자주 사용됩니다.\n'raise customer satisfaction'은 어색한 조합입니다.\n'develop customer satisfaction'은 어색한 조합입니다.",
    translation:
      "회사는 응답 시간을 개선하여 고객 만족도를 달성하는 것을 목표로 하고 있다.",
  },
  {
    id: 6,
    koreanQuestion: "고용 계약서는 명확히 _______ 계약의 조건과 조항을.",
    question:
      "The employment contract clearly ______ the terms and conditions of the agreement.",
    choices: {
      a: "states",
      b: "writes",
      c: "declares",
      d: "mentions",
    },
    correctAnswer: "a",
    explanation:
      "'state the terms and conditions'(계약 조건을 명시하다)이 가장 자연스러운 콜로케이션입니다.\n\n'write the terms and conditions'는 문법적으로 가능하지만, 공식적인 문장에서는 'state'를 사용합니다.\n'declare'는 선언하는 의미가 강해 어색합니다.\n'mention'은 가볍게 언급하는 의미라 공식 계약서 맥락에 부적절합니다.",
    translation: "고용 계약서는 계약의 조건과 조항을 명확히 명시한다.",
  },
  {
    id: 7,
    koreanQuestion:
      "회의에서는 _______ 주요 문제를. 회사의 확장 전략과 관련된 ",
    question:
      "The meeting ______ key issues regarding the company's expansion strategy.",
    choices: {
      a: "addressed",
      b: "spoke",
      c: "told",
      d: "explained",
    },
    correctAnswer: "a",
    explanation:
      "'address key issues'(주요 문제를 다루다)가 가장 자연스러운 콜로케이션입니다.\n\n'spoke'는 'speak about'와 함께 사용되어야 자연스럽습니다.\n'told'는 보통 'tell someone about something' 형태로 사용됩니다.\n'explained'는 'explain something to someone' 형태가 더 자연스럽습니다.",
    translation: "회의에서는 회사의 확장 전략과 관련된 주요 문제를 다루었다.",
  },
  {
    id: 8,
    koreanQuestion:
      "회사는 결정했다 _______ 계약을 공급업체와의 품질 문제로 인해",
    question:
      "The company decided to ______ its contract with the supplier due to quality issues.",
    choices: {
      a: "terminate",
      b: "finish",
      c: "complete",
      d: "suspend",
    },
    correctAnswer: "a",
    explanation:
      "'terminate a contract'(계약을 해지하다)가 가장 자연스러운 콜로케이션입니다.\n\n'finish a contract'는 부적절한 표현입니다.\n'complete a contract'는 계약을 완료한다는 의미로 해지와는 다릅니다.\n'suspend a contract'는 계약을 일시 중단한다는 의미로 영구적 해지와는 다릅니다.",
    translation:
      "회사는 품질 문제로 인해 공급업체와의 계약을 해지하기로 결정했다.",
  },
  {
    id: 9,
    koreanQuestion: "의장은 _______ 안건을 논의를 시작하기 전에",
    question:
      "The chairperson ______ the agenda before beginning the discussion.",
    choices: {
      a: "announced",
      b: "introduced",
      c: "disclosed",
      d: "revealed",
    },
    correctAnswer: "b",
    explanation:
      "'introduce the agenda'(안건을 소개하다)가 가장 자연스러운 콜로케이션입니다.\n\n'announce the agenda'는 공표한다는 의미로 회의 맥락에서는 부자연스럽습니다.\n'disclose the agenda'는 비밀을 공개한다는 뉘앙스가 있어 부적절합니다.\n'reveal the agenda'도 숨겨진 것을 드러낸다는 의미로 회의 안건 소개에는 적절하지 않습니다.",
    translation: "의장은 논의를 시작하기 전에 안건을 소개했다.",
  },

  {
    id: 10,
    koreanQuestion: "회사는 _______ 상당한 손실을 시장 수요의 급감으로 인해",
    question:
      "The company ______ a significant loss due to the sudden decline in market demand.",
    choices: {
      a: "faced",
      b: "spent",
      c: "delivered",
      d: "prevented",
    },
    correctAnswer: "a",
    explanation:
      "'face a loss'(손실을 직면하다)가 가장 자연스러운 콜로케이션입니다.\n\n'spend a loss'는 어색한 표현입니다.\n'deliver a loss'는 부적절한 표현입니다.\n'prevent a loss'는 손실을 예방한다는 의미로 문맥상 맞지 않습니다.",
    translation: "회사는 시장 수요의 급감으로 인해 상당한 손실을 직면했다.",
  },
  {
    id: 11,
    koreanQuestion:
      "협상 당사자들은 마침내 _______ 합의를 여러 차례의 논의 끝에",
    question:
      "The negotiating parties finally ______ a consensus after several rounds of discussions.",
    choices: {
      a: "achieved",
      b: "obtained",
      c: "reached",
      d: "conducted",
    },
    correctAnswer: "c",
    explanation:
      "'reach a consensus'(합의에 도달하다)가 가장 자연스러운 콜로케이션입니다.\n\n'achieve a consensus'도 가능하지만 'reach'가 더 일반적으로 사용됩니다.\n'obtain a consensus'는 부자연스러운 표현입니다.\n'conduct a consensus'는 부적절한 표현입니다.",
    translation:
      "협상 당사자들은 여러 차례의 논의 끝에 마침내 합의에 도달했다.",
  },
  {
    id: 12,
    koreanQuestion:
      "광고 캠페인은 성공적으로 _______ 브랜드 인지도를 젊은 소비자들 사이에서",
    question:
      "The advertising campaign successfully ______ brand awareness among young consumers.",
    choices: {
      a: "increased",
      b: "built",
      c: "raised",
      d: "improved",
    },
    correctAnswer: "c",
    explanation:
      "'raise brand awareness'(브랜드 인지도를 높이다)가 가장 자연스러운 콜로케이션입니다.\n\n'increase brand awareness'도 가능하지만 'raise'가 더 일반적으로 사용됩니다.\n'build brand awareness'는 덜 일반적인 표현입니다.\n'improve brand awareness'는 부자연스러운 표현입니다.",
    translation:
      "광고 캠페인은 젊은 소비자들 사이에서 브랜드 인지도를 성공적으로 높였다.",
  },
  {
    id: 13,
    koreanQuestion: "신입 직원은 빠르게 _______ 자신의 직무를 팀에 적응하면서",
    question:
      "The new employee quickly ______ his responsibilities and adapted to the team.",
    choices: {
      a: "performed",
      b: "fulfilled",
      c: "executed",
      d: "assumed",
    },
    correctAnswer: "d",
    explanation:
      "'assume responsibilities'(직무를 맡다)가 가장 자연스러운 콜로케이션입니다.\n\n'fulfill responsibilities'는 의무를 수행한다는 의미로 덜 적절합니다.\n'perform responsibilities'와 'execute responsibilities'는 부자연스러운 표현입니다.",
    translation: "신입 직원은 빠르게 자신의 직무를 맡고 팀에 적응했다.",
  },
  {
    id: 14,
    koreanQuestion:
      "마케팅 디렉터는 _______ 상세한 프레젠테이션을 소비자 행동 트렌드에 대해",
    question:
      "The marketing director ______ a detailed presentation on consumer behavior trends.",
    choices: {
      a: "gave",
      b: "conducted",
      c: "presented",
      d: "performed",
    },
    correctAnswer: "a",
    explanation:
      "'give a presentation'(프레젠테이션을 하다)가 가장 자연스러운 콜로케이션입니다.\n\n'conduct a presentation'은 어색한 표현입니다.\n'present a presentation'은 중복된 표현으로 부자연스럽습니다.\n'perform a presentation'은 부적절한 표현입니다.",
    translation:
      "마케팅 디렉터는 소비자 행동 트렌드에 대한 상세한 프레젠테이션을 진행했다.",
  },
  {
    id: 15,
    koreanQuestion: "매니저는 _______ 몇 가지 주요 업무를 시니어 팀원들에게",
    question: "The manager ______ several key tasks to senior team members.",
    choices: {
      a: "allocated",
      b: "assigned",
      c: "distributed",
      d: "transferred",
    },
    correctAnswer: "b",
    explanation:
      "'assign tasks'(업무를 할당하다)가 가장 자연스러운 콜로케이션입니다.\n\n'allocate tasks'도 가능하지만 일반적으로 예산이나 자원을 배분할 때 사용됩니다.\n'distribute tasks'와 'transfer tasks'는 부자연스러운 표현입니다.",
    translation: "매니저는 몇 가지 주요 업무를 시니어 팀원들에게 할당했다.",
  },
  {
    id: 16,
    koreanQuestion:
      "회사는 모색하고 있다  _______ 새로운 기회를 글로벌 확장을 위한",
    question:
      "The company is looking to ______ new opportunities for global expansion.",
    choices: {
      a: "pursue",
      b: "obtain",
      c: "seek",
      d: "explore",
    },
    correctAnswer: "d",
    explanation:
      "'explore opportunities'(기회를 탐색하다)가 가장 자연스러운 콜로케이션입니다.\n\n'seek opportunities'도 가능하지만 'explore'가 더 일반적으로 사용됩니다.\n'pursue opportunities'와 'obtain opportunities'는 덜 자연스러운 표현입니다.",
    translation: "회사는 글로벌 확장을 위한 새로운 기회를 모색하고 있다.",
  },
  {
    id: 17,
    koreanQuestion:
      "회사는 성공적으로  _______ 매출을 혁신적인 가격 전략을 통해",
    question:
      "The company successfully ______ its revenue through an innovative pricing strategy.",
    choices: {
      a: "improved",
      b: "raised",
      c: "boosted",
      d: "expanded",
    },
    correctAnswer: "c",
    explanation:
      "'boost revenue'(매출을 증가시키다)가 가장 자연스러운 콜로케이션입니다.\n\n'improve revenue'는 어색한 표현입니다.\n'raise revenue'는 문법적으로 가능하지만 'boost'가 더 일반적으로 사용됩니다.\n'expand revenue'는 부자연스러운 표현입니다.",
    translation:
      "회사는 혁신적인 가격 전략을 통해 매출을 성공적으로 증가시켰다.",
  },
  {
    id: 18,
    koreanQuestion: "몇 주간의 논의 끝에, 두 회사는 마침내 _______ 거래를",
    question:
      "After weeks of discussion, the companies finally ______ the deal.",
    choices: {
      a: "reached",
      b: "closed",
      c: "signed",
      d: "executed",
    },
    correctAnswer: "b",
    explanation:
      "'close a deal'(거래를 성사시키다)이 가장 자연스러운 콜로케이션입니다.\n\n'reach a deal'도 가능하지만 최종적인 마무리의 의미는 'close'가 더 적절합니다.\n'sign a deal'과 'execute a deal'은 법적 문서에 더 적합한 표현입니다.",
    translation: "몇 주간의 논의 끝에, 두 회사는 마침내 거래를 성사시켰다.",
  },
  {
    id: 19,
    koreanQuestion:
      "회사는 목표로 하고 있다 _______ 강력한 브랜드 이미지를 시장에서",
    question: "The company aims to ______ a strong brand image in the market.",
    choices: {
      a: "develop",
      b: "establish",
      c: "build",
      d: "maintain",
    },
    correctAnswer: "b",
    explanation:
      "'establish a brand image'(브랜드 이미지를 구축하다)가 가장 자연스러운 콜로케이션입니다.\n\n'develop a brand image'는 브랜드 아이덴티티 개발의 맥락에서 사용됩니다.\n'build a brand image'와 'maintain a brand image'는 문법적으로 가능하지만 'establish'가 더 전문적이고 일반적인 표현입니다.",
    translation:
      "회사는 시장에서 강력한 브랜드 이미지를 구축하는 것을 목표로 하고 있다.",
  },
  {
    id: 20,
    koreanQuestion: "인사부는 _______ 직원의 성과를 분기별로",
    question:
      "The HR department ______ employee performance on a quarterly basis.",
    choices: {
      a: "assesses",
      b: "judges",
      c: "rates",
      d: "observes",
    },
    correctAnswer: "a",
    explanation:
      "'assess performance'(성과를 평가하다)가 가장 자연스러운 콜로케이션입니다.\n\n'judge performance'는 주관적인 판단의 의미가 강해 부적절합니다.\n'rate performance'는 단순히 등급을 매기는 의미라 포괄적인 평가의 의미가 부족합니다.\n'observe performance'는 단순 관찰의 의미로, 평가의 의미가 부족합니다.",
    translation: "인사부는 분기별로 직원의 성과를 평가한다.",
  },
  {
    id: 21,
    koreanQuestion: "팀은 열심히 노력하고 있다 _______ 프로젝트 마감 기한을",
    question: "The team is working hard to ______ the project deadline.",
    choices: {
      a: "meet",
      b: "catch",
      c: "reach",
      d: "fulfill",
    },
    correctAnswer: "a",
    explanation:
      "'meet a deadline'(마감 기한을 맞추다)가 가장 자연스러운 콜로케이션입니다.\n\n'catch a deadline'은 부자연스러운 표현입니다.\n'reach a deadline'은 마감 기한에 도달한다는 의미로 부적절합니다.\n'fulfill a deadline'은 영어에서 사용되지 않는 표현입니다.",
    translation: "팀은 프로젝트 마감 기한을 맞추기 위해 열심히 노력하고 있다.",
  },
  {
    id: 22,
    koreanQuestion: "법무팀은 _______ 계약 조건을 최종 승인 전에",
    question:
      "The legal team ______ the terms of the contract before final approval.",
    choices: {
      a: "altered",
      b: "revised",
      c: "adjusted",
      d: "modified",
    },
    correctAnswer: "b",
    explanation:
      "'revise terms/contract'(계약 조건을 수정하다)가 가장 자연스러운 콜로케이션입니다.\n\n'alter terms'는 문법적으로 가능하지만 법률 문서에서는 덜 일반적입니다.\n'adjust terms'와 'modify terms'는 부적절한 표현입니다.",
    translation: "법무팀은 최종 승인 전에 계약 조건을 수정했다.",
  },
  {
    id: 23,
    koreanQuestion: "두 회사는 성공적으로 _______ 거래를 몇 주간의 협상 끝에",
    question:
      "The two companies successfully ______ a deal after weeks of negotiation.",
    choices: {
      a: "secured",
      b: "signed",
      c: "executed",
      d: "made",
    },
    correctAnswer: "a",
    explanation:
      "'secure a deal'(거래를 성사시키다)가 가장 자연스러운 콜로케이션입니다.\n\n'sign a deal'은 문법적으로 가능하지만 주로 계약서에 서명하는 행위를 의미합니다.\n'execute a deal'과 'make a deal'은 비즈니스 맥락에서 부자연스러운 표현입니다.",
    translation: "두 회사는 몇 주간의 협상 끝에 거래를 성사시켰다.",
  },
  {
    id: 24,
    koreanQuestion: "법무팀은 _______ 모든 계약 조항을 계약 체결 전에",
    question:
      "The legal team must ______ all contractual clauses before finalizing the agreement.",
    choices: {
      a: "assess",
      b: "interpret",
      c: "scrutinize",
      d: "draft",
    },
    correctAnswer: "c",
    explanation:
      "'scrutinize clauses'(조항을 면밀히 검토하다)가 가장 자연스러운 콜로케이션입니다.\n\n'assess clauses'는 단순 평가의 의미로 부적절합니다.\n'interpret clauses'는 해석의 의미로 검토와는 다릅니다.\n'draft clauses'는 초안을 작성한다는 의미로 맥락상 부적절합니다.",
    translation:
      "법무팀은 계약 체결 전에 모든 계약 조항을 면밀히 검토해야 한다.",
  },
  {
    id: 25,
    koreanQuestion: "회사는 _______ 포괄적인 시장 분석을 신제품 출시 전에",
    question:
      "The company plans to ______ a comprehensive market analysis before launching the new product.",
    choices: {
      a: "conduct",
      b: "facilitate",
      c: "execute",
      d: "compile",
    },
    correctAnswer: "a",
    explanation:
      "'conduct an analysis'(분석을 수행하다)가 가장 자연스러운 콜로케이션입니다.\n\n'facilitate an analysis'는 분석을 촉진한다는 의미로 부적절합니다.\n'execute an analysis'는 주로 기술적 테스트에 사용됩니다.\n'compile an analysis'는 분석 자료를 편집한다는 의미로 맥락상 부적절합니다.",
    translation:
      "회사는 신제품 출시 전에 포괄적인 시장 분석을 수행할 계획이다.",
  },
  {
    id: 26,
    koreanQuestion: "프로젝트 매니저는 _______ 업무를 팀원들에게  효율적으로",
    question:
      "The project manager must ______ responsibilities among the team members efficiently.",
    choices: {
      a: "assign",
      b: "distribute",
      c: "delegate",
      d: "allocate",
    },
    correctAnswer: "c",
    explanation:
      "'delegate responsibilities'(책임을 위임하다)가 가장 자연스러운 콜로케이션입니다.\n\n'assign responsibilities'는 가능하지만 주로 개별 작업에 사용됩니다.\n'distribute responsibilities'와 'allocate responsibilities'는 업무 위임의 맥락에서 부자연스럽습니다.",
    translation:
      "프로젝트 매니저는 팀원들에게 업무를 효율적으로 위임해야 한다.",
  },
  {
    id: 27,
    koreanQuestion: "회사는 시작했다 캠페인을 _______ 소비자 참여를 위한 ",
    question: "The company launched a campaign to ______ consumer engagement.",
    choices: {
      a: "cultivate",
      b: "maintain",
      c: "stimulate",
      d: "foster",
    },
    correctAnswer: "c",
    explanation:
      "'stimulate engagement'(참여를 촉진하다)가 가장 자연스러운 콜로케이션입니다.\n\n'cultivate engagement'는 부자연스러운 표현입니다.\n'maintain engagement'는 기존 참여도 유지에 적합합니다.\n'foster engagement'는 가능하지만 장기적 발전의 맥락에서 더 적절합니다.",
    translation: "회사는 소비자 참여를 촉진하기 위한 캠페인을 시작했다.",
  },
  {
    id: 28,
    koreanQuestion: "회사는 _______  새로운 시장에 동남아시아의",
    question: "The company is aiming to ______ new markets in Southeast Asia.",
    choices: {
      a: "target",
      b: "approach",
      c: "engage",
      d: "penetrate",
    },
    correctAnswer: "d",
    explanation:
      "'penetrate markets'(시장에 진입하다)가 가장 자연스러운 콜로케이션입니다.\n\n'target markets'는 마케팅 대상으로 삼는다는 의미로 맥락이 다릅니다.\n'approach markets'와 'engage markets'는 시장 진입의 맥락에서 부자연스러운 표현입니다.",
    translation:
      "회사는 동남아시아의 새로운 시장에 진출하는 것을 목표로 하고 있다.",
  },
  {
    id: 29,
    koreanQuestion: "고객들은 권장된다 _______ 불만을 공식 지원 채널을 통해.",
    question:
      "Customers are encouraged to ______ complaints through the official support channel.",
    choices: {
      a: "file",
      b: "request",
      c: "submit",
      d: "demand",
    },
    correctAnswer: "a",
    explanation:
      "'file complaints'(불만을 제기하다)가 가장 자연스러운 콜로케이션입니다.\n\n'submit complaints'는 가능하지만 법적 용어로는 'file'이 더 일반적입니다.\n'request complaints'와 'demand complaints'는 불만 제기의 맥락에서 부자연스러운 표현입니다.",
    translation: "고객들은 공식 지원 채널을 통해 불만을 제기하도록 권장된다.",
  },
  {
    id: 30,
    koreanQuestion:
      "재무 부서는 신중하게 _______ 연간 예산을 비용 효율성을 보장하기 위해 ",
    question:
      "The finance department must carefully ______ the annual budget to ensure cost efficiency.",
    choices: {
      a: "oversee",
      b: "allocate",
      c: "evaluate",
      d: "monitor",
    },
    correctAnswer: "b",
    explanation:
      "'allocate budget'(예산을 할당하다)가 가장 자연스러운 콜로케이션입니다.\n\n'monitor budget'은 예산 집행을 감시하는 의미로 가능하지만 맥락상 부적절합니다.\n'oversee budget'과 'evaluate budget'은 예산 관리의 맥락에서 부자연스러운 표현입니다.",
    translation:
      "재무 부서는 비용 효율성을 보장하기 위해 연간 예산을 신중하게 할당해야 한다.",
  },
  {
    id: 31,
    koreanQuestion: "회사는 계획하고 있다 _______  국제 시장에서의 입지를.",
    question:
      "The company is planning to ______ its presence in international markets.",
    choices: {
      a: "enlarge",
      b: "broaden",
      c: "extend",
      d: "establish",
    },
    correctAnswer: "b",
    explanation:
      "'broaden presence'(입지를 넓히다)가 가장 자연스러운 콜로케이션입니다.\n\n'extend presence'는 어색한 표현입니다.\n'enlarge presence'와 'establish presence'는 기업의 시장 입지 확장의 맥락에서 부자연스러운 표현입니다.",
    translation: "회사는 국제 시장에서의 입지를 넓히는 것을 계획하고 있다.",
  },
  {
    id: 32,
    koreanQuestion: "재무 분석가는 요청 받았다 _______  상세한 손익 보고서를.",
    question:
      "The financial analyst was asked to ______ a detailed profit and loss report.",
    choices: {
      a: "compile",
      b: "conduct",
      c: "execute",
      d: "generate",
    },
    correctAnswer: "a",
    explanation:
      "'compile a report'(보고서를 작성하다)가 가장 자연스러운 콜로케이션입니다.\n\n'conduct a report'는 문법적으로 틀린 표현입니다.\n'execute a report'와 'generate a report'는 보고서 작성의 맥락에서 부자연스러운 표현입니다.",
    translation: "재무 분석가는 상세한 손익 보고서를 작성하도록 요청받았다.",
  },
  {
    id: 33,
    koreanQuestion: "회사는 노력한다 _______ 강력한 관계를 / 주요 파트너들과.",
    question:
      "The company strives to ______ strong relationships with key partners.",
    choices: {
      a: "establish",
      b: "maintain",
      c: "foster",
      d: "build",
    },
    correctAnswer: "d",
    explanation:
      "'build relationships'(관계를 구축하다)가 가장 자연스러운 콜로케이션입니다.\n\n'establish relationships'도 가능하지만 새로운 관계를 처음 만들 때 더 적합합니다.\n'maintain relationships'와 'foster relationships'는 비즈니스 관계 구축의 맥락에서 덜 자연스러운 표현입니다.",
    translation: "회사는 주요 파트너들과 강력한 관계를 구축하기 위해 노력한다.",
  },
  {
    id: 34,
    koreanQuestion:
      "재무 부서는 제안했다 _______ 예산을 / 비용을 최소화하기 위해.",
    question:
      "The finance department proposed a ______ budget to minimize expenses.",
    choices: {
      a: "strict",
      b: "limited",
      c: "tight",
      d: "narrow",
    },
    correctAnswer: "c",
    explanation:
      "'tight budget'(빠듯한 예산)이 가장 자연스러운 콜로케이션입니다.\n\n'limited budget'도 사용 가능하지만 'tight budget'이 비용 절감의 맥락에서 더 일반적입니다.\n'strict budget'과 'narrow budget'은 예산 관리의 맥락에서 부자연스러운 표현입니다.",
    translation: "재무 부서는 비용을 최소화하기 위해 빠듯한 예산을 제안했다.",
  },
  {
    id: 35,
    koreanQuestion: "회사는 접수했다 _______ 불만을 / 불만족한 고객으로부터.",
    question:
      "The company received a ______ complaint from a dissatisfied customer.",
    choices: {
      a: "strong",
      b: "formal",
      c: "official",
      d: "harsh",
    },
    correctAnswer: "b",
    explanation:
      "'formal complaint'(공식적인 불만)이 가장 자연스러운 콜로케이션입니다.\n\n'strong complaint'은 부적절한 표현입니다.\n'official complaint'은 가능하지만 'formal complaint'가 더 일반적입니다.\n'harsh complaint'은 고객 불만 접수의 맥락에서 부자연스러운 표현입니다.",
    translation: "회사는 불만족한 고객으로부터 공식적인 불만을 접수했다.",
  },
  {
    id: 36,
    koreanQuestion:
      "CEO는 내렸다 _______ 결정을 / 회사의 미래에 중대한 영향을 미치는.",
    question:
      "The CEO made a ______ decision that significantly impacted the company's future.",
    choices: {
      a: "critical",
      b: "vital",
      c: "necessary",
      d: "strategic",
    },
    correctAnswer: "d",
    explanation:
      "'strategic decision'(전략적 결정)이 가장 자연스러운 콜로케이션입니다.\n\n'critical decision'도 가능하지만 전략적인 판단을 강조하는 맥락에서는 'strategic decision'이 더 적절합니다.\n'vital decision'과 'necessary decision'은 기업의 전략적 의사결정 맥락에서 덜 자연스러운 표현입니다.",
    translation:
      "CEO는 회사의 미래에 중대한 영향을 미치는 전략적 결정을 내렸다.",
  },
  {
    id: 37,
    koreanQuestion:
      "프로젝트 매니저는 수행한다 _______ 역할을 / 팀이 마감 기한을 맞출 수 있도록 하는 데.",
    question:
      "The project manager plays a ______ role in ensuring the team meets deadlines.",
    choices: {
      a: "primary",
      b: "crucial",
      c: "strong",
      d: "key",
    },
    correctAnswer: "d",
    explanation:
      "'key role'(중요한 역할)이 가장 자연스러운 콜로케이션입니다.\n\n'crucial role'도 사용 가능하지만 'key role'이 더 일반적입니다.\n'primary role'과 'strong role'은 이 맥락에서 부자연스러운 표현입니다.",
    translation:
      "프로젝트 매니저는 팀이 마감 기한을 맞출 수 있도록 하는 데 중요한 역할을 수행한다.",
  },
  {
    id: 38,
    koreanQuestion:
      "회사는 시작했다 _______ 광고 캠페인을 / 젊은 고객을 유치하기 위해.",
    question:
      "The company launched an ______ advertising campaign to attract younger customers.",
    choices: {
      a: "aggressive",
      b: "forceful",
      c: "powerful",
      d: "competitive",
    },
    correctAnswer: "a",
    explanation:
      "'aggressive campaign'(공격적인 광고 캠페인)이 가장 자연스러운 콜로케이션입니다.\n\n'forceful campaign'은 부자연스러운 표현입니다.\n'powerful campaign'과 'competitive campaign'은 가능하지만 마케팅 전략의 맥락에서 'aggressive campaign'이 더 일반적입니다.",
    translation:
      "회사는 젊은 고객을 유치하기 위해 공격적인 광고 캠페인을 시작했다.",
  },
  {
    id: 39,
    koreanQuestion:
      "회계 부서는 제출했다 _______ 보고서를 / 회사의 연간 수익에 대한.",
    question:
      "The accounting department submitted a ______ report on the company's annual earnings.",
    choices: {
      a: "detailed",
      b: "precise",
      c: "extensive",
      d: "accurate",
    },
    correctAnswer: "a",
    explanation:
      "'detailed report'(상세한 보고서)가 가장 자연스러운 콜로케이션입니다.\n\n'precise report'는 수치적 정확성을 강조할 때 더 적합합니다.\n'extensive report'와 'accurate report'는 가능하지만 재무 보고서의 맥락에서는 'detailed report'가 더 일반적입니다.",
    translation:
      "회계 부서는 회사의 연간 수익에 대한 상세한 보고서를 제출했다.",
  },
  {
    id: 40,
    koreanQuestion:
      "고객 지원팀은 제공했다 _______ 응답을 / 고객의 문의에 대한.",
    question:
      "The customer support team provided a ______ response to the client's inquiry.",
    choices: {
      a: "quick",
      b: "immediate",
      c: "prompt",
      d: "fast",
    },
    correctAnswer: "c",
    explanation:
      "'prompt response'(즉각적인 응답)가 가장 자연스러운 콜로케이션입니다.\n\n'quick response'와 'immediate response'도 사용 가능하지만 'prompt response'가 더 전문적이고 일반적입니다.\n'fast response'는 이 맥락에서 부자연스러운 표현입니다.",
    translation: "고객 지원팀은 고객의 문의에 신속한 응답을 제공했다.",
  },
  {
    id: 41,
    koreanQuestion: "회사는 찾고 있다 _______ 기회를 / 아시아 시장에서.",
    question:
      "The company is looking for ______ opportunities in the Asian market.",
    choices: {
      a: "potential",
      b: "possible",
      c: "feasible",
      d: "emerging",
    },
    correctAnswer: "a",
    explanation:
      "'potential opportunities'(잠재적인 기회)가 가장 자연스러운 콜로케이션입니다.\n\n'possible opportunities'와 'feasible opportunities'는 어색한 표현입니다.\n'emerging opportunities'는 특정 산업의 변화나 발전 상황을 설명할 때 더 적합합니다.",
    translation: "회사는 아시아 시장에서 잠재적인 기회를 찾고 있다.",
  },
  {
    id: 42,
    koreanQuestion:
      "회의 의제는 초점을 맞추었다 _______ 문제에 / 회사 확장과 관련된.",
    question:
      "The meeting agenda focused on ______ matters related to the company's expansion.",
    choices: {
      a: "essential",
      b: "significant",
      c: "relevant",
      d: "pressing",
    },
    correctAnswer: "d",
    explanation:
      "'pressing matters'(긴급한 문제)가 가장 자연스러운 콜로케이션입니다.\n\n'relevant matters'도 가능하지만 회의 의제의 맥락에서는 'pressing matters'가 더 적절합니다.\n'essential matters'와 'significant matters'는 덜 일반적인 표현입니다.",
    translation:
      "회의 의제는 회사 확장과 관련된 긴급한 문제에 초점을 맞추었다.",
  },
  {
    id: 43,
    koreanQuestion:
      "새로운 비즈니스 모델은 설계되었다 _______ 수익원을 / 창출하도록.",
    question:
      "The new business model is designed to generate ______ revenue streams.",
    choices: {
      a: "steady",
      b: "large",
      c: "significant",
      d: "continuous",
    },
    correctAnswer: "a",
    explanation:
      "'steady revenue streams'(안정적인 수익 흐름)가 가장 자연스러운 콜로케이션입니다.\n\n'large revenue streams'와 'significant revenue streams'는 사용 가능하지만 비즈니스 모델의 지속가능성을 설명할 때는 'steady'가 더 적절합니다.\n'continuous revenue streams'는 부자연스러운 표현입니다.",
    translation:
      "새로운 비즈니스 모델은 안정적인 수익원을 창출하도록 설계되었다.",
  },
  {
    id: 44,
    koreanQuestion:
      "강한 리더십은 _______ 요소이다 / 회사의 장기적인 성공에서.",
    question:
      "Strong leadership is a ______ factor in a company's long-term success.",
    choices: {
      a: "decisive",
      b: "key",
      c: "critical",
      d: "significant",
    },
    correctAnswer: "a",
    explanation:
      "'decisive factor'(결정적인 요소)가 가장 자연스러운 콜로케이션입니다.\n\n'key factor'도 사용 가능하지만 'decisive'가 더 강조된 의미를 전달합니다.\n'critical factor'와 'significant factor'는 덜 일반적인 표현입니다.",
    translation: "강한 리더십은 회사의 장기적인 성공에서 결정적인 요소이다.",
  },
  {
    id: 45,
    koreanQuestion:
      "설문 조사 결과는 보여준다 _______ 선호도를 / 친환경 제품에 대한",
    question:
      "The survey results indicate a ______ preference for eco-friendly products.",
    choices: {
      a: "rising",
      b: "growing",
      c: "improving",
      d: "increasing",
    },
    correctAnswer: "b",
    explanation:
      "'growing preference'(증가하는 선호도)가 가장 자연스러운 콜로케이션입니다.\n\n'increasing preference'도 문법적으로 가능하지만 'growing'이 더 자연스럽게 사용됩니다.\n'rising preference'와 'improving preference'는 부자연스러운 표현입니다.",
    translation:
      "설문 조사 결과는 친환경 제품에 대한 증가하는 선호도를 보여준다.",
  },
  {
    id: 46,
    koreanQuestion:
      "회사는 노력하고 있다 _______ 책임을 다하기 위해 / 지역 사회에 대한",
    question:
      "The company is committed to fulfilling its ______ responsibility to the community.",
    choices: {
      a: "corporate",
      b: "financial",
      c: "operational",
      d: "critical",
    },
    correctAnswer: "a",
    explanation:
      "'corporate responsibility'(기업의 사회적 책임)가 가장 자연스러운 콜로케이션입니다.\n\n'financial responsibility'는 재무적 책임을 의미하므로 맥락상 부적절합니다.\n'operational responsibility'와 'critical responsibility'는 부자연스러운 표현입니다.",
    translation:
      "회사는 지역 사회에 대한 기업의 사회적 책임을 다하기 위해 노력하고 있다.",
  },
  {
    id: 47,
    koreanQuestion: "회사는 모색하고 있다 _______ 기회를 / 글로벌 시장에서",
    question:
      "The company is exploring ______ opportunities in the global market.",
    choices: {
      a: "vast",
      b: "considerable",
      c: "lucrative",
      d: "promising",
    },
    correctAnswer: "d",
    explanation:
      "'promising opportunities'(유망한 기회)가 가장 자연스러운 콜로케이션입니다.\n\n'lucrative opportunities'도 사용 가능하지만 주로 투자 기회를 설명할 때 더 적절합니다.\n'vast opportunities'와 'considerable opportunities'는 덜 일반적인 표현입니다.",
    translation: "회사는 글로벌 시장에서 유망한 기회를 모색하고 있다.",
  },
  {
    id: 48,
    koreanQuestion:
      "회의에서는 다루었다 _______ 주제를 / 회사 확장과 관련된 논란이 되는",
    question:
      "The meeting covered several ______ topics related to the company's expansion.",
    choices: {
      a: "controversial",
      b: "essential",
      c: "valuable",
      d: "current",
    },
    correctAnswer: "a",
    explanation:
      "'controversial topics'(논란이 되는 주제)가 가장 자연스러운 콜로케이션입니다.\n\n'essential topics'는 핵심적인 주제를 의미하지만 맥락상 부적절합니다.\n'valuable topics'와 'current topics'는 이 맥락에서 부자연스러운 표현입니다.",
    translation:
      "회의에서는 회사 확장과 관련된 여러 논란이 되는 주제를 다루었다.",
  },
  {
    id: 49,
    koreanQuestion:
      "CEO는 발표했다 _______ 계획을 / 해외 시장으로 확장하기 위한",
    question:
      "The CEO announced a ______ plan to expand into international markets.",
    choices: {
      a: "bold",
      b: "careful",
      c: "impressive",
      d: "extensive",
    },
    correctAnswer: "a",
    explanation:
      "'bold plan'(대담한 계획)이 가장 자연스러운 콜로케이션입니다.\n\n'extensive plan'은 광범위한 계획을 의미하지만 도전적인 의미가 없어 맥락상 부적절합니다.\n'careful plan'과 'impressive plan'은 부자연스러운 표현입니다.",
    translation: "CEO는 해외 시장으로 확장하기 위한 대담한 계획을 발표했다.",
  },
  {
    id: 50,
    koreanQuestion:
      "매장은 제공한다 _______ 반품 정책을 / 구매에 만족하지 않는 고객을 위한",
    question:
      "The store offers a ______ return policy for customers who are not satisfied with their purchase.",
    choices: {
      a: "generous",
      b: "reasonable",
      c: "acceptable",
      d: "valid",
    },
    correctAnswer: "a",
    explanation:
      "'generous return policy'(관대한 반품 정책)가 가장 자연스러운 콜로케이션입니다.\n\n'reasonable return policy'는 납득할 만한 반품 정책을 의미하지만 고객 친화적인 의미가 부족합니다.\n'acceptable'과 'valid'는 반품 정책과 함께 사용되는 일반적인 표현이 아닙니다.",
    translation:
      "매장은 구매에 만족하지 않는 고객을 위한 관대한 반품 정책을 제공한다.",
  },
  {
    id: 51,
    koreanQuestion:
      "계약에는 포함되어 있다 _______ 조건이 / 양측이 준수해야 하는",
    question:
      "The contract contains ______ conditions that both parties must adhere to.",
    choices: {
      a: "binding",
      b: "severe",
      c: "tough",
      d: "flexible",
    },
    correctAnswer: "a",
    explanation:
      "'binding conditions'(구속력 있는 조건)이 가장 자연스러운 콜로케이션입니다.\n\n'severe conditions'는 심각한 조건을 의미하며 법적 구속력의 의미와는 거리가 있습니다.\n'tough conditions'와 'flexible conditions'는 이 맥락에서 부적절한 표현입니다.",
    translation:
      "계약에는 양측이 준수해야 하는 구속력 있는 조건이 포함되어 있다.",
  },
  {
    id: 52,
    koreanQuestion: "회사는 경험했다 _______ 성장을 / 지난 분기 매출에서",
    question: "The company experienced ______ growth in revenue last quarter.",
    choices: {
      a: "substantial",
      b: "considerable",
      c: "incremental",
      d: "extensive",
    },
    correctAnswer: "a",
    explanation:
      "'substantial growth'(상당한 성장)가 가장 자연스러운 콜로케이션입니다.\n\n'incremental growth'는 점진적인 성장을 의미하며 큰 성장을 나타내는 맥락과 맞지 않습니다.\n'considerable'과 'extensive'는 성장을 표현할 때 덜 일반적으로 사용되는 표현입니다.",
    translation: "회사는 지난 분기 매출에서 상당한 성장을 경험했다.",
  },
  {
    id: 53,
    koreanQuestion:
      "회사는 제공한다 _______ 복리후생을 / 건강 보험과 퇴직 연금 계획을 포함한",
    question:
      "The company provides ______ benefits, including health insurance and retirement plans.",
    choices: {
      a: "comprehensive",
      b: "valuable",
      c: "moderate",
      d: "exceptional",
    },
    correctAnswer: "a",
    explanation:
      "'comprehensive benefits'(포괄적인 복리후생)가 가장 자연스러운 콜로케이션입니다.\n\n'valuable benefits'는 주관적인 표현이라 덜 일반적입니다.\n'moderate benefits'와 'exceptional benefits'는 복리후생을 설명할 때 잘 사용되지 않는 표현입니다.",
    translation:
      "회사는 건강 보험과 퇴직 연금 계획을 포함한 포괄적인 복리후생을 제공한다.",
  },
  {
    id: 54,
    koreanQuestion: "회사는 유명하다 _______ 서비스를 / 고객들에게 제공하는",
    question:
      "The company is known for providing ______ service to its customers.",
    choices: {
      a: "outstanding",
      b: "sufficient",
      c: "competent",
      d: "acceptable",
    },
    correctAnswer: "a",
    explanation:
      "'outstanding service'(뛰어난 서비스)가 가장 자연스러운 콜로케이션입니다.\n\n'sufficient service'는 서비스를 설명할 때 어색한 표현입니다.\n'competent service'와 'acceptable service'는 서비스의 품질을 설명할 때 일반적으로 사용되지 않는 표현입니다.",
    translation: "회사는 고객들에게 뛰어난 서비스를 제공하는 것으로 유명하다.",
  },
  {
    id: 55,
    koreanQuestion: "매니저는 수행했다 _______ 평가를 / 팀의 성과에 대한",
    question:
      "The manager conducted a ______ assessment of the team's performance.",
    choices: {
      a: "fair",
      b: "accurate",
      c: "thorough",
      d: "impartial",
    },
    correctAnswer: "c",
    explanation:
      "'thorough assessment'(철저한 평가)가 가장 자연스러운 콜로케이션입니다.\n\n'accurate assessment'는 정확성을 강조하는 의미라서 덜 일반적입니다.\n'fair assessment'와 'impartial assessment'는 평가의 공정성을 나타내지만 이 맥락에서는 적절하지 않습니다.",
    translation: "매니저는 팀의 성과에 대한 철저한 평가를 수행했다.",
  },
  {
    id: 56,
    koreanQuestion:
      "새로운 스마트폰 모델은 경험하고 있다 _______ 수요를 / 글로벌 시장에서",
    question:
      "The new smartphone model is experiencing ______ demand in the global market.",
    choices: {
      a: "rising",
      b: "high",
      c: "excessive",
      d: "steady",
    },
    correctAnswer: "b",
    explanation:
      "'high demand'(높은 수요)가 가장 자연스러운 콜로케이션입니다.\n\n'rising demand'는 증가하는 추세를 나타내지만 현재 상태를 설명하기에는 덜 적절합니다.\n'excessive demand'는 부정적인 뉘앑스가 있어 적절하지 않습니다.\n'steady demand'는 안정적인 수요를 의미하지만 이 맥락에서는 적절하지 않습니다.",
    translation:
      "새로운 스마트폰 모델은 글로벌 시장에서 높은 수요를 경험하고 있다.",
  },
  {
    id: 57,
    koreanQuestion:
      "우리는 감사히 생각합니다 _______ 피드백을 / 최근 제품 출시에 대한 귀하의",
    question:
      "We appreciate your ______ feedback on our recent product launch.",
    choices: {
      a: "useful",
      b: "valuable",
      c: "meaningful",
      d: "informative",
    },
    correctAnswer: "b",
    explanation:
      "'valuable feedback'(소중한 피드백)이 가장 자연스러운 콜로케이션입니다.\n\n'useful feedback'은 사용 가능하지만 'valuable'보다 덜 자연스럽습니다.\n'meaningful feedback'과 'informative feedback'은 피드백을 설명할 때 일반적으로 사용되지 않는 표현입니다.",
    translation:
      "우리는 최근 제품 출시에 대한 귀하의 소중한 피드백을 감사히 생각합니다.",
  },
  {
    id: 58,
    koreanQuestion:
      "직원들은 받았다 _______ 통지를 / 회사가 본사를 이전하기 전에",
    question:
      "Employees were given ______ notice before the company relocated its headquarters.",
    choices: {
      a: "early",
      b: "advanced",
      c: "prior",
      d: "former",
    },
    correctAnswer: "c",
    explanation:
      "'prior notice'(사전 통지)가 가장 자연스러운 콜로케이션입니다.\n\n'advanced notice'는 문법적으로는 맞지만 'prior notice'가 더 일반적으로 사용됩니다.\n'early notice'와 'former notice'는 이 맥락에서 적절하지 않은 표현입니다.",
    translation: "직원들은 회사가 본사를 이전하기 전에 사전 통지를 받았다.",
  },
  {
    id: 59,
    koreanQuestion:
      "계약에는 포함되어 있다 _______ 조항이 / 양측을 보호하는 여러",
    question:
      "The agreement includes several ______ provisions that protect both parties.",
    choices: {
      a: "protective",
      b: "defensive",
      c: "legal",
      d: "contractual",
    },
    correctAnswer: "d",
    explanation:
      "'contractual provisions'(계약 조항)이 가장 자연스러운 콜로케이션입니다.\n\n'legal provisions'도 사용 가능하지만 계약 맥락에서는 'contractual'이 더 적절합니다.\n'protective provisions'와 'defensive provisions'는 일반적으로 사용되지 않는 표현입니다.",
    translation: "계약에는 양측을 보호하는 여러 계약 조항이 포함되어 있다.",
  },
  {
    id: 60,
    koreanQuestion: "매니저는 장려했다 _______ 논의를 / 전략 회의에서",
    question:
      "The manager encouraged ______ discussion during the strategy meeting.",
    choices: {
      a: "lively",
      b: "energetic",
      c: "noisy",
      d: "active",
    },
    correctAnswer: "a",
    explanation:
      "'lively discussion'(활발한 논의)이 가장 자연스러운 콜로케이션입니다.\n\n'active discussion'은 직역하면 자연스럽지만 원어민들은 'lively'를 더 선호합니다.\n'energetic discussion'과 'noisy discussion'은 회의 맥락에서 적절하지 않은 표현입니다.",
    translation: "매니저는 전략 회의에서 활발한 논의를 장려했다.",
  },
  {
    id: 61,
    koreanQuestion:
      "회사는 기울이고 있다 _______ 노력을 / 고객 만족도를 개선하기 위한",
    question:
      "The company is implementing ______ efforts to improve customer satisfaction.",
    choices: {
      a: "constant",
      b: "ongoing",
      c: "strong",
      d: "firm",
    },
    correctAnswer: "b",
    explanation:
      "'ongoing efforts'(지속적인 노력)이 가장 자연스러운 콜로케이션입니다.\n\n'constant efforts'는 의미상 비슷하지만 'ongoing'이 더 자연스럽게 사용됩니다.\n'strong efforts'와 'firm efforts'는 일반적으로 사용되지 않는 표현입니다.",
    translation:
      "회사는 고객 만족도를 개선하기 위한 지속적인 노력을 기울이고 있다.",
  },

  {
    id: 62,
    koreanQuestion: "두 회사는 아직 합의하지 않았다 _______ 계약의 최종 가격에",
    question:
      "The two companies have not yet agreed ______ the final price of the contract.",
    choices: {
      a: "in",
      b: "with",
      c: "on",
      d: "for",
    },
    correctAnswer: "c",
    explanation:
      "'agree on + 명사'(~에 대해 합의하다)가 가장 자연스러운 표현입니다.\n\n'agree with'는 사람과 동의할 때 사용되므로 이 문맥에서는 부적절합니다.\n'agree in'과 'agree for'는 문법적으로 틀린 표현입니다.",
    translation: "두 회사는 아직 계약의 최종 가격에 대해 합의하지 않았다.",
  },
  {
    id: 63,
    koreanQuestion:
      "팀은 열심히 일하고 있다 완료하기 위해 프로젝트를  _______ 마감 기한",
    question:
      "The team is working hard to finish the project ______ the deadline.",
    choices: {
      a: "within",
      b: "in",
      c: "at",
      d: "by",
    },
    correctAnswer: "d",
    explanation:
      "'by the deadline'(마감 기한까지)가 가장 자연스러운 표현입니다.\n\n'within the deadline'은 어색한 표현입니다('within a time frame'이라면 가능).\n'in the deadline'과 'at the deadline'은 문법적으로 부적절한 표현입니다.",
    translation:
      "팀은 마감 기한까지 프로젝트를 완료하기 위해 열심히 일하고 있다.",
  },
  {
    id: 64,
    koreanQuestion: "모든 직원들은 참석해야 한다 _______ 회의에  정시에 ",
    question: "All employees are expected to be ______ the meeting on time.",
    choices: {
      a: "at",
      b: "in",
      c: "on",
      d: "to",
    },
    correctAnswer: "a",
    explanation:
      "'be at the meeting'(회의에 참석하다)가 가장 자연스러운 표현입니다.\n\n'be in the meeting'은 회의 중이라는 의미로 사용되므로 참석 여부를 나타내는 이 맥락에서는 부적절합니다.\n'be on the meeting'과 'be to the meeting'은 문법적으로 틀린 표현입니다.",
    translation: "모든 직원들은 회의에 정시에 참석해야 한다.",
  },
  {
    id: 65,
    koreanQuestion: "보고서는 보여주었다 매출 감소를 _______ 경기 침체로 인한",
    question:
      "The report showed a decline ______ revenue due to economic downturns.",
    choices: {
      a: "in",
      b: "of",
      c: "on",
      d: "at",
    },
    correctAnswer: "a",
    explanation:
      "'decline in + 명사'(~의 감소)가 가장 자연스러운 표현입니다.\n\n'decline of'는 특정 숫자나 퍼센트와 함께 사용될 때만 적절합니다(예: 'a decline of 10%').\n'decline on'과 'decline at'은 문법적으로 틀린 표현입니다.",
    translation: "그 보고서는 경기 침체로 인해 매출 감소를 보여주었다.",
  },
  {
    id: 66,
    koreanQuestion:
      "그 회사는 많은 투자를 하고 있다 _______ 채용하는 데 업계 최고의 인재를 ",
    question:
      "The company is investing heavily ______ recruiting top talent in the industry.",
    choices: {
      a: "on",
      b: "in",
      c: "at",
      d: "with",
    },
    correctAnswer: "b",
    explanation:
      "'invest in + 명사'(~에 투자하다)가 가장 자연스러운 표현입니다.\n\n'invest on'은 틀린 표현입니다('spend on'이라면 가능).\n'invest at'과 'invest with'는 문법적으로 부적절한 표현입니다.",
    translation:
      "그 회사는 업계 최고의 인재를 채용하는 데 많은 투자를 하고 있다.",
  },
  {
    id: 67,
    koreanQuestion:
      "경영팀은 여러 대안을 고려하고 있다 _______ 현재 전략에 대한",
    question:
      "The management team is considering several alternatives ______ the current strategy.",
    choices: {
      a: "to",
      b: "for",
      c: "with",
      d: "on",
    },
    correctAnswer: "a",
    explanation:
      "'alternative to + 명사'(~에 대한 대안)가 올바른 표현입니다.\n\n'alternative for'는 흔히 발생하는 오류이지만 문법적으로 틀린 표현입니다.\n'alternative with'와 'alternative on'은 부적절한 전치사 사용입니다.",
    translation: "경영팀은 현재 전략에 대한 여러 대안을 고려하고 있다.",
  },
  {
    id: 68,
    koreanQuestion: "두 회사는 체결했다 _______ 파트너십 계약을",
    question: "The two companies have entered ______ a partnership agreement.",
    choices: {
      a: "with",
      b: "on",
      c: "into",
      d: "for",
    },
    correctAnswer: "c",
    explanation:
      "'enter into + 계약/합의'(계약을 체결하다)가 가장 자연스러운 표현입니다.\n\n'enter with', 'enter on', 'enter for'는 모두 계약 체결을 표현할 때 사용되지 않는 부적절한 표현입니다.",
    translation: "두 회사는 파트너십 계약을 체결했다.",
  },

  {
    id: 69,
    koreanQuestion: "재무 보고서는 나타냈다 _______ 매출의 급감을 / 이번 분기",
    question:
      "The financial report indicated a sharp drop ______ sales this quarter.",
    choices: {
      a: "at",
      b: "on",
      c: "with",
      d: "in",
    },
    correctAnswer: "d",
    explanation:
      "'drop in + 명사'(~의 감소)가 가장 자연스러운 표현입니다.\n\n'drop at', 'drop on', 'drop with'는 모두 매출 감소를 표현할 때 사용되지 않는 부적절한 표현입니다.",
    translation: "재무 보고서는 이번 분기에 매출이 급감했음을 나타냈다.",
  },
  {
    id: 70,
    koreanQuestion: "양측은 준수해야 한다 _______ 계약서에 명시된 조건을",
    question:
      "Both parties must abide ______ the terms and conditions outlined in the agreement.",
    choices: {
      a: "on",
      b: "to",
      c: "by",
      d: "with",
    },
    correctAnswer: "c",
    explanation:
      "'abide by + 규정/법률'(~을 준수하다)가 가장 자연스러운 표현입니다.\n\n'abide to'는 흔히 발생하는 오류이지만 문법적으로 틀린 표현입니다.\n'abide on'과 'abide with'는 부적절한 전치사 사용입니다.",
    translation: "양측은 계약서에 명시된 조건을 준수해야 한다.",
  },
  {
    id: 71,
    koreanQuestion: "회사는 겪고 있다 어려움을  _______ 공급망의 문제로",
    question: "The company is struggling with issues ______ the supply chain.",
    choices: {
      a: "with",
      b: "in",
      c: "on",
      d: "at",
    },
    correctAnswer: "b",
    explanation:
      "'issues in + 시스템/구조'가 가장 자연스러운 표현입니다.\n\n'issues with'는 특정 사물이나 사람과의 문제를 나타낼 때 사용됩니다.\n'issues on'과 'issues at'는 공급망 문제를 표현할 때 사용되지 않는 부적절한 표현입니다.",
    translation: "회사는 공급망에서 발생한 문제로 어려움을 겪고 있다.",
  },
  {
    id: 72,
    koreanQuestion:
      "고객 지원팀은 제공했다 해결책을 _______ 기술적 문제에 대해 24시간 이내에",
    question:
      "The support team provided a solution ______ the technical issue within 24 hours.",
    choices: {
      a: "to",
      b: "for",
      c: "at",
      d: "with",
    },
    correctAnswer: "a",
    explanation:
      "'solution to + 문제'(~에 대한 해결책)가 가장 자연스러운 표현입니다.\n\n'solution for'는 흔히 사용되지만 덜 자연스러운 표현입니다.\n'solution at'과 'solution with'는 문제 해결을 표현할 때 사용되지 않는 부적절한 표현입니다.",
    translation:
      "고객 지원팀은 24시간 이내에 기술적 문제에 대한 해결책을 제공했다.",
  },
  {
    id: 73,
    koreanQuestion:
      "투자자들은 보였다 큰 관심을 _______ 회사의 최신 재무 보고서",
    question:
      "Investors showed great interest ______ the company's latest financial report.",
    choices: {
      a: "on",
      b: "in",
      c: "with",
      d: "at",
    },
    correctAnswer: "b",
    explanation:
      "'interest in + 명사'(~에 대한 관심)가 가장 자연스러운 표현입니다.\n\n'interest on'은 흔히 발생하는 오류이며 문법적으로 틀린 표현입니다.\n'interest with'와 'interest at'는 관심을 표현할 때 사용되지 않는 부적절한 표현입니다.",
    translation: "투자자들은 회사의 최신 재무 보고서에 큰 관심을 보였다.",
  },
  {
    id: 74,
    koreanQuestion:
      "프로젝트는 완료되어야 한다 _______ 예산  / 재정적 문제를 피하기 위해",
    question:
      "The project must be completed ______ budget to avoid financial issues.",
    choices: {
      a: "at",
      b: "under",
      c: "with",
      d: "in",
    },
    correctAnswer: "b",
    explanation:
      "'under budget'(예산 내에서)가 가장 자연스러운 표현입니다.\n\n'in budget'은 흔히 발생하는 오류이며 문법적으로 틀린 표현입니다.\n'at budget'과 'with budget'은 예산 관련 표현에서 사용되지 않는 부적절한 표현입니다.",
    translation:
      "프로젝트는 재정적 문제를 피하기 위해 예산 내에서 완료되어야 한다.",
  },
  {
    id: 75,
    koreanQuestion:
      "상당한 변화가 있었다 _______ 소비자 선호도에 / 최근 몇 년 동안",
    question:
      "There has been a significant shift ______ consumer preferences in recent years.",
    choices: {
      a: "to",
      b: "in",
      c: "with",
      d: "on",
    },
    correctAnswer: "b",
    explanation:
      "'shift in + 명사'(~에서의 변화)가 가장 자연스러운 표현입니다.\n\n'shift to'는 특정 방향으로의 전환을 의미하므로 이 맥락에서는 부적절합니다.\n'shift with'와 'shift on'은 변화를 표현할 때 사용되지 않는 부적절한 표현입니다.",
    translation: "최근 몇 년 동안 소비자 선호도에 상당한 변화가 있었다.",
  },
  {
    id: 76,
    koreanQuestion: "회사는 확대하려 하고 있다 입지를 _______ 아시아 시장에서",
    question:
      "The company is looking to expand its presence ______ the Asian market.",
    choices: {
      a: "at",
      b: "in",
      c: "to",
      d: "on",
    },
    correctAnswer: "b",
    explanation:
      "'expand presence in + 시장/지역'(~에서 입지를 확대하다)가 가장 자연스러운 표현입니다.\n\n'expand presence to'는 문법적으로 틀린 표현입니다.\n'expand presence at'과 'expand presence on'은 입지 확대를 표현할 때 사용되지 않는 부적절한 표현입니다.",
    translation: "회사는 아시아 시장에서 입지를 확대하려 하고 있다.",
  },
  {
    id: 77,
    koreanQuestion:
      "두 회사 간의 계약은 유효할 것이다 어느 한쪽이 결정할때까지 철회하기로  _______ 계약에서 ",
    question:
      "The agreement between the two companies will remain valid until either party decides to withdraw ______ the contract.",
    choices: {
      a: "from",
      b: "in",
      c: "with",
      d: "on",
    },
    correctAnswer: "a",
    explanation:
      "'withdraw from + 계약/계획'(~에서 철회하다)가 가장 자연스러운 표현입니다.\n\n'withdraw in'은 문법적으로 틀린 표현입니다.\n'withdraw with'와 'withdraw on'은 계약 철회를 표현할 때 사용되지 않는 부적절한 표현입니다.",
    translation:
      "두 회사 간의 계약은 어느 한쪽이 계약에서 철회하기로 결정할 때까지 유효하다.",
  },
  {
    id: 78,
    koreanQuestion: "회사는 준수해야 한다 _______ 모든 적용 가능한 규정을",
    question:
      "The company must ensure compliance ______ all applicable regulations.",
    choices: {
      a: "in",
      b: "on",
      c: "to",
      d: "with",
    },
    correctAnswer: "d",
    explanation:
      "'compliance with + 규정'(~을 준수하다)가 가장 자연스러운 표현입니다.\n\n'compliance to'는 문법적으로 틀린 표현입니다.\n'compliance in'과 'compliance on'은 규정 준수를 표현할 때 사용되지 않는 부적절한 표현입니다.",
    translation: "그 회사는 모든 적용 가능한 규정을 준수해야 한다.",
  },
  {
    id: 79,
    koreanQuestion:
      "프로젝트 팀은 현재 일정이 늦어지고 있지만 노력하고 있다 돌리기 위해 이를 _______  ",
    question:
      "The project team is currently behind schedule but is working hard to bring it ______ track.",
    choices: {
      a: "on",
      b: "in",
      c: "to",
      d: "back",
    },
    correctAnswer: "d",
    explanation:
      "'bring back on track'(정상 궤도로 돌리다)이 가장 자연스러운 표현입니다.\n\n'bring in track'은 문법적으로 틀린 표현입니다.\n'bring on track'과 'bring to track'은 정상 궤도로 돌리는 것을 표현할 때 사용되지 않는 부적절한 표현입니다.",
    translation:
      "프로젝트 팀은 현재 일정이 늦어지고 있지만, 이를 다시 정상 궤도로 돌리기 위해 노력하고 있다.",
  },
  {
    id: 80,
    koreanQuestion: "예기치 않은 지출로 인해, 회사의 지출이 _______ 예산을",
    question:
      "Due to unforeseen expenses, the company's expenditures have gone ______ budget.",
    choices: {
      a: "beyond",
      b: "in",
      c: "with",
      d: "under",
    },
    correctAnswer: "a",
    explanation:
      "'go beyond budget'(예산을 초과하다)가 가장 자연스러운 콜로케이션입니다.\n\n'go in budget'은 문법적으로 틀린 표현입니다.\n'go with budget'과 'go under budget'은 예산 초과를 표현할 때 사용되지 않는 부적절한 표현입니다.",
    translation: "예기치 않은 지출로 인해 회사의 지출이 예산을 초과했다.",
  },
  {
    id: 81,
    koreanQuestion: "고객은 문의했다 _______ 자신의 환불 상태에 대해",
    question: "The customer inquired ______ the status of his refund.",
    choices: {
      a: "to",
      b: "for",
      c: "about",
      d: "with",
    },
    correctAnswer: "c",
    explanation:
      "'inquire about + 명사'(~에 대해 문의하다)가 가장 자연스러운 콜로케이션입니다.\n\n'inquire to'는 문법적으로 틀린 표현입니다.\n'inquire for'와 'inquire with'는 문의를 표현할 때 사용되지 않는 부적절한 표현입니다.",
    translation: "고객은 자신의 환불 상태에 대해 문의했다.",
  },
  {
    id: 82,
    koreanQuestion:
      "회의가 일정 충돌로 인해 다음 주 월요일로 _______ 다시 잡혔다",
    question:
      "The meeting was rescheduled ______ next Monday due to a scheduling conflict.",
    choices: {
      a: "on",
      b: "to",
      c: "for",
      d: "in",
    },
    correctAnswer: "c",
    explanation:
      "'reschedule for + 날짜'(~로 일정을 다시 잡다)가 가장 자연스러운 콜로케이션입니다.\n\n'reschedule to'는 문법적으로 틀린 표현입니다.\n'reschedule on'과 'reschedule in'은 일정 변경을 표현할 때 사용되지 않는 부적절한 표현입니다.",
    translation: "회의가 일정 충돌로 인해 다음 주 월요일로 다시 잡혔다.",
  },
  {
    id: 83,
    koreanQuestion:
      "재무 보고서는 _______ 회사의 이익과 손실에 대한 개요를 제공한다",
    question:
      "The financial report provides an overview ______ the company's profits and losses.",
    choices: {
      a: "on",
      b: "of",
      c: "about",
      d: "for",
    },
    correctAnswer: "b",
    explanation:
      "'provide an overview of + 명사'(~에 대한 개요를 제공하다)가 가장 자연스러운 콜로케이션입니다.\n\n'overview on'은 문법적으로 틀린 표현입니다.\n'overview about'와 'overview for'는 개요를 표현할 때 사용되지 않는 부적절한 표현입니다.",
    translation: "재무 보고서는 회사의 이익과 손실에 대한 개요를 제공한다.",
  },
  {
    id: 84,
    koreanQuestion:
      "CEO는 회사의 새로운 지속 가능성 이니셔티브에 대한 _______ 발표를 했다",
    question:
      "The CEO made an announcement ______ the company's new sustainability initiatives.",
    choices: {
      a: "on",
      b: "to",
      c: "with",
      d: "for",
    },
    correctAnswer: "a",
    explanation:
      "'make an announcement on + 명사'(~에 대한 발표를 하다)가 가장 자연스러운 콜로케이션입니다.\n\n'announcement to'는 문법적으로 틀린 표현입니다.\n'announcement with'와 'announcement for'는 발표를 표현할 때 사용되지 않는 부적절한 표현입니다.",
    translation:
      "CEO는 회사의 새로운 지속 가능성 이니셔티브에 대한 발표를 했다.",
  },
];
